import styles from "./SettingsHistoricalAchievementsPage.module.css";
import { useSettingsHistoricalAchievementsViewModel } from "@/features/settings/viewModal/useSettingsHistoricalAchievementsViewModel";
import { Gifs } from "@/assets/gifs";

export const SettingsHistoricalAchievementsPage = () => {
  const vm = useSettingsHistoricalAchievementsViewModel();
  const {
    milestones,
    loading,
    error,
    totalProtests,
    completedProtests,
    wonProtests,
    lostProtests,
    displaySavings,
  } = vm;

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>
        <span>Your Tax </span>
        <span className={styles.titleAccent}>Protest Achievements</span>
      </h1>

      <div className={styles.hero}>
        <img src={Gifs.andyConfetti} alt="Confetti celebration" className={styles.heroLogo} />
      </div>

      {loading && <section className={styles.infoCard}>Loading achievements...</section>}
      {!loading && error && <section className={styles.infoCard}>{error}</section>}

      {!loading && !error && (
        <>
          <section className={styles.summaryGrid}>
            <article className={`${styles.summaryCard} ${styles.savingsCard}`}>
              <span className={styles.summaryLabel}>Your Total Tax Savings:</span>
              <strong className={styles.summaryValue}>{displaySavings}</strong>
            </article>
            <article className={styles.summaryCard}>
              <span className={styles.summaryLabel}>Status:</span>
              <strong className={styles.summaryValue}>{totalProtests} active protests</strong>
            </article>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Achievements Earned</h2>
            <div className={styles.milestoneList}>
              {milestones.length === 0 && (
                <article className={styles.milestoneCard}>No achievements yet.</article>
              )}
              {milestones.map((milestone) => (
                <article className={styles.milestoneCard} key={milestone.id}>
                  <div className={styles.milestoneStripe} />
                  <div className={styles.milestoneContent}>
                    <h3 className={styles.milestoneTitle}>{milestone.title}</h3>
                    <p className={styles.milestoneDesc}>{milestone.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Performance Overview</h2>
            <div className={styles.metricsGrid}>
              <article className={styles.metricCard}>
                <strong className={styles.metricValue}>{totalProtests}</strong>
                <span className={styles.metricLabel}>Total Protests</span>
              </article>
              <article className={styles.metricCard}>
                <strong className={styles.metricValue}>{completedProtests}</strong>
                <span className={styles.metricLabel}>Completed</span>
              </article>
              <article className={styles.metricCard}>
                <strong className={`${styles.metricValue} ${styles.win}`}>{wonProtests}</strong>
                <span className={styles.metricLabel}>Won</span>
              </article>
              <article className={styles.metricCard}>
                <strong className={`${styles.metricValue} ${styles.loss}`}>{lostProtests}</strong>
                <span className={styles.metricLabel}>Lost</span>
              </article>
            </div>
          </section>
        </>
      )}
    </div>
  );
};
